import React from 'react';
import cn from "../../lib/bem";

import './inputCheck_component.scss';

const InputCheckComponent = (props) => {

    const classes = cn("inputCheckComponent");

    return (
        <div className={classes()}>
            <label className={classes('inputCheckLabel')}> {props.inputText}
                <input className={classes('inputCheckInput')} aria-label='chkProteccion' name={`chk_${props.inputText}`} type="checkbox" checked={props.inputValue} onChange={ () => props.inputAction(!props.inputValue)} />
                <span className={classes('inputCheckSpan')}></span>
            </label>
        </div>
    );
};

export default InputCheckComponent;